import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import { Preview } from '../../../../helpers/ui/FileInput'
import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response
                        })
                        console.log(response)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Detail Pensiun</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Pensiun
                                    </CardSubtitle>
                                    <hr />

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        NIP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_nip !== "" ? this.state.detail.retired_employee_nip : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Nama
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_name !== "" ? this.state.detail.retired_employee_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Unit Kerja
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_work_unit_name !== "" ? this.state.detail.retired_employee_work_unit_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Jabatan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_position_name !== "" ? this.state.detail.retired_employee_position_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        TMT Jabatan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_position_tmt !== "" ? this.state.detail.retired_employee_position_tmt : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Golongan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_level_name !== "" ? this.state.detail.retired_employee_level_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Tanggal Lahir
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_birth_date !== "" ? this.state.detail.retired_employee_birth_date : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Jenis Kelamin
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.gender_name !== "" ? this.state.detail.gender_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Tanggal Pensiun
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_retired_date !== "" ? this.state.detail.retired_employee_retired_date : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        TMT Pensiun
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_retired_date_tmt !== "" ? this.state.detail.retired_employee_retired_date_tmt : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Jenis
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_type_name !== "" ? this.state.detail.retired_type_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Usia
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_age !== "" ? this.state.detail.employee_age : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Usia Pensiun
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_age_retired !== "" ? this.state.detail.employee_age_retired : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        Sisa Masa Kerja
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_work_age !== "" ? this.state.detail.employee_work_age : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        TUSK
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_tusk !== "" ? this.state.detail.retired_employee_tusk : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                        MPP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.retired_employee_mpp !== "" ? this.state.detail.retired_employee_mpp : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                         Dokumen
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.documents_path !== "" ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.detail.documents_path}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                   
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="/kepegawaian/pensiun.html" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                    
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);